export const CRM_FEATURES = {
  COMMUNICATOR_CALLING: 'COMMUNICATOR_CALLING',
  COMMUNICATOR_EMAIL: 'COMMUNICATOR_EMAIL'
};
export const ALL_FEATURES = ['COMMUNICATOR_CALLING', 'COMMUNICATOR_EMAIL'];